/**
 * Auth-вызовы: POST /v1/auth/login → JWT.
 *
 * Тонкая обёртка над `@hsc/api-client.customFetch`. baseURL зафиксирован на
 * `/v1`, совпадает с контрактом бэкенда.
 */
import { customFetch } from '@hsc/api-client';

export interface LoginRequest {
  email: string;
  password: string;
  device?: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token?: string;
  token_type?: 'Bearer';
  expires_in?: number;
}

/** POST /v1/auth/login. */
export async function login(req: LoginRequest): Promise<LoginResponse> {
  return customFetch<LoginResponse>({
    url: '/auth/login',
    method: 'POST',
    data: req,
    baseURL: '/v1',
  });
}

/** POST /v1/auth/refresh — обновляет access-токен по refresh-токену. */
export async function refreshSession(refreshToken: string): Promise<LoginResponse> {
  return customFetch<LoginResponse>({
    url: '/auth/refresh',
    method: 'POST',
    data: { refresh_token: refreshToken },
    baseURL: '/v1',
    noAuth: true,
  });
}

export interface ChangePasswordRequest {
  /** UUID текущего пользователя (из /v1/me). */
  user_id: string;
  old_password: string;
  new_password: string;
}

/**
 * POST /v1/auth/change-password — смена пароля по текущему паролю (#80).
 * 204 No Content при успехе; 401 — неверный текущий пароль; 422 — слабый новый
 * (политика: минимум 12 символов).
 */
export async function changePassword(req: ChangePasswordRequest): Promise<void> {
  await customFetch<void>({
    url: '/auth/change-password',
    method: 'POST',
    data: req,
    baseURL: '/v1',
  });
}
